import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Dashboard from "./Pages/Dashboard";
import Login from "./Pages/Login";
import ForgetPassword from "./Pages/Login/ForgetPassword";
import NewPassword from "./Pages/Login/NewPassword";
import ResetPassword from "./Pages/Login/ResetPassword";
import Signup from "./Pages/Signup";
import ConfirmPassword from "./Pages/Signup/ConfirmPassword";
import CreatePin from "./Pages/Signup/CreatePin";
import VerifyAccount from "./Pages/Signup/VerifyAccount";
import React, { useEffect, useContext, Suspense } from "react";
import cookie from "react-cookies";
import Delete from "./Pages/Delete";
import { UserContext } from "./Context/UserContext";
import Logout from "./Pages/logout";
import DashboardSkeleton from "./Components/SkeletonComponent/DashboardSkeleton";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setLogoutHandler } from "./Services/api";


const App = () => {
  const { isLoggedIn, logout } = useContext(UserContext);
  useEffect(() => {
    
    setLogoutHandler(logout);
  }, [logout]);

  useEffect(() => {
    let refreshInterval;
    let cookieCheckInterval;

    if (isLoggedIn) {
      // check if the token has been deleted by the browser after token 15-minute expiration
      cookieCheckInterval = setInterval(() => {
        const currentToken = cookie.load("token") || cookie.load("jwttoken");
        if (!currentToken) {
          // Token was deleted after being inactive for 15mins, logout user
          logout();
        }
      }, 3000);

      const handleRefreshToken = () => {
        const currentToken = cookie.load("token") || cookie.load("jwttoken");
        if (!currentToken) {
          logout(); 
          return;
        }

        import("./Services/post-service").then((module) => {
          const postService = module.default;
          postService
            .refreshToken()
            .then((response) => {
              if (response.data.statusCode === 200) {
                const token = response.data.data.token;
                // calculates new expiry time for the token (15mins)
                const expiry = new Date(Date.now() + 15 * 60 * 1000);
                cookie.save("token", token, { path: "/", expires: expiry });
                cookie.save("jwttoken", token, { path: "/", expires: expiry });
              }
            })
            .catch((error) => {
              logout();
            });
        });
      };

      // Refresh token every 10 minutes to keep session alive
      refreshInterval = setInterval(handleRefreshToken, 600000);
    }

    return () => {
      if (refreshInterval) clearInterval(refreshInterval);
      if (cookieCheckInterval) clearInterval(cookieCheckInterval);
    };
  }, [isLoggedIn, logout]);

  return (
    <BrowserRouter>
      <ToastContainer />
      <Suspense fallback={<DashboardSkeleton />}>
        <Routes>
          {isLoggedIn ? (
            <>
              <Route path="/logout" element={<Logout />} />
              <Route path="*" element={<Dashboard />} />
            </>
          ) : (
            <>
              <Route path="/" element={<Login />} />
              <Route path="/forgetpassword" element={<ForgetPassword />} />
              <Route path="/newpassword" element={<NewPassword />} />
              <Route path="/resetpassword" element={<ResetPassword />} />
              <Route path="/deleteaccount" element={<Delete />} />
              <Route path="/sign-up" element={<Signup />} />
              <Route path="/confirmpassword" element={<ConfirmPassword />} />
              <Route path="/createpin" element={<CreatePin />} />
              <Route path="/verifyaccount" element={<VerifyAccount />} />
              <Route path="*" element={<Login />} />
            </>
          )}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
